import React from 'react';
import { Container, Layout, Stack } from '@fiverr-private/layout_components';
import { Image } from '@fiverr-private/media';
import { Typography } from '@fiverr-private/typography';
import { appTranslate } from '../../i18n';
import { CARDS } from './cards';
import { MOBILE } from './constants';
import { mobileCard, mobileStage } from './styles.ve.css';

interface MobileStageProps {
    hidden?: Record<string, boolean>;
}

export const MobileStage: React.FC<MobileStageProps> = ({ hidden }) => (
    <Container hidden={hidden} className={mobileStage}>
        {CARDS.map(({ key, images }) => (
            <Layout key={key} className={mobileCard} paddingTop="16" paddingX="5" paddingBottom="8">
                <Stack direction="column" gap="12">
                    <Stack direction="column" gap="8">
                        <Typography as="h2" fontWeight="semibold" color="black" style={MOBILE.type.heading}>
                            {appTranslate(`values.panels.${key}.heading`)}
                        </Typography>

                        <Typography
                            as="p"
                            fontWeight="light"
                            color="black"
                            size={{ default: 'b_md', md: 'b_lg' }}
                            style={MOBILE.type.body}
                        >
                            {appTranslate(`values.panels.${key}.body`)}
                        </Typography>
                    </Stack>

                    <Stack direction="column" gap="6">
                        {[images[0], images[1]].map((src, idx) => (
                            <Container
                                key={`value-img-${idx}`}
                                width="100%"
                                overflow="hidden"
                                borderRadius="xl"
                                style={{ aspectRatio: '320 / 212' }}
                            >
                                <Image src={src} alt="" objectFit="cover" width="100%" height="100%" />
                            </Container>
                        ))}
                    </Stack>
                </Stack>
            </Layout>
        ))}
    </Container>
);
